export default __webpack_public_path__ + "static/jewel-6c77e9bedfc5e7d89e5861462b50ffd6.png";